export const GROUP_FILES = `
query groupFiles($tenant_id: Int!, $group_id: Int!) {
  groupFiles(tenant_id: $tenant_id, group_id: $group_id) {
    __typename
    ... on GroupFile {
      id
      group_id
      filename
      mimetype
      encoding
      url
      its
    }
    ... on ResultError {
      status_code
      message
      message_translation_key
    }
  }
}
`;
